import { H3Event } from 'h3';
import { QueryTypes } from '~/server/utils/contentstack';
import { getFirstIndex } from '~/util/arrays';
import { extractComponent } from '~/util/contentstack/csHelpers';
import { contentstackRequest } from '~/util/contentstack/api';

type CommunityDataResponse = Promise<{ page?: any; sections?: any; mainContent?: any; error?: unknown }>;

export async function fetchCommunity({
  event = undefined,
  query,
}: {
  event?: H3Event;
  query?: {
    locale?: string;
  };
}): CommunityDataResponse {
  try {
    let mainContent: any = null;
    let sections: any = null;
    const $cfFetch = cfFetchBuilder(event);
    let lpUrl = '/api/contentstack/communityLP';
    let lpSectionsUrl = '/api/contentstack/communityLPSections';
    if (query?.locale) {
      lpUrl += `?locale=${query.locale}`;
      lpSectionsUrl += `?locale=${query.locale}`;
    }

    [mainContent, sections] = await Promise.all([$cfFetch(lpUrl), $cfFetch(lpSectionsUrl)]);

    const page = getFirstIndex(mainContent?.data?.all_community_landing_page?.items);
    sections = getFirstIndex(sections?.data?.all_community_landing_page?.items)?.sections;
    return {
      page,
      sections,
      mainContent,
    };
  } catch (error) {
    return Promise.resolve({ error });
  }
}

type CommunityCategoryDataResponse = Promise<{
  postType?: string;
  slug?: string;
  allPosts?: any;
  locale?: string;
  fetchRes?: any;
  category?: any;
  error?: unknown;
}>;
export async function fetchCommunityCategory({
  slug,
  postType,
  query,
  event = undefined,
}: {
  slug?: string;
  postType: string;
  query?: {
    locale?: string;
  };
  event?: H3Event;
}): CommunityCategoryDataResponse {
  try {
    let fetchRes: any = null;
    let category: any = null;
    const $cfFetch = cfFetchBuilder(event);
    const locale = query?.locale;
    if (!slug) {
      fetchRes = await $cfFetch(`/api/contentstack/all-posts?limit=${120}&postType=${postType}&locale=${locale}`);
    } else {
      // get blogs with slug/type
      [fetchRes, category] = await Promise.all([
        $cfFetch(`/api/contentstack/community-post-cat-post?cat=${'/' + slug}&postType=${postType}&locale=${locale}`),
        $cfFetch(`/api/contentstack/community-category?url=${'/' + slug}&locale=${locale}`),
      ]);
    }

    const allPosts = fetchRes?.data?.all_community_posts?.items;
    return {
      postType,
      slug,
      allPosts,
      locale,
      fetchRes,
      category: category?.data?.all_community_category?.items?.length
        ? category.data.all_community_category.items[0]
        : undefined,
    };
  } catch (error) {
    return Promise.resolve({ error });
  }
}

type CommunityPostDataResponse = Promise<{
  slug?: string | undefined;
  post?: any;
  locale?: string;
  fetchRes?: any;
  mainCategory?: any;
  relatedPosts?: any;
  postType?: string;
  error?: unknown;
}>;
export async function fetchCommunityPost({
  slug,
  postType,
  postQuery,
  query,
  event = undefined,
}: {
  slug?: string;
  postQuery: QueryTypes;
  postType?: string;
  query?: {
    locale?: string;
  };
  event?: H3Event;
}): CommunityPostDataResponse {
  try {
    const fetchRes = await contentstackRequest(postQuery, '/' + slug, {
      event,
      query,
    });
    // @ts-expect-error
    const post = getFirstIndex(fetchRes?.data?.all_community_posts?.items);
    const mainCategory = extractComponent(post?.categoriesConnection);
    const $cfFetch = cfFetchBuilder(event);
    let relatedPosts: any = null;
    if (mainCategory) {
      relatedPosts = await $cfFetch(
        `/api/contentstack/community-post-cat-post?cat=${mainCategory?.url}&postType=${postType}&locale=${query?.locale}`
      );
      relatedPosts = relatedPosts?.data?.all_community_posts?.items;
    }

    return {
      slug,
      post,
      locale: query?.locale,
      fetchRes,
      mainCategory,
      relatedPosts,
      postType,
    };
  } catch (error) {
    return Promise.resolve({ error });
  }
}
